import { put, call } from 'redux-saga/effects';
import { validateClientAdd, validateClientDetails, validateEventAdd, validateCrewAdd, validateCrewDetails } from '../services/validateService';

import * as types from '../actions';

export function* validateClientAddSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(validateClientAdd, payload);
    yield put({ type: types.VALIDATE_CLIENT_ADD_SUCCESS, response }); 
          
  } catch(error) {
    yield put({ type: types.VALIDATE_CLIENT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* validateClientDetailsSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(validateClientDetails, payload);
    yield put({ type: types.VALIDATE_CLIENT_DETAILS_SUCCESS, response }); 
          
  } catch(error) {
    yield put({ type: types.VALIDATE_CLIENT_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* validateEventAddSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(validateEventAdd, payload);
    yield put({ type: types.VALIDATE_EVENT_ADD_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.VALIDATE_EVENT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* validateCrewAddSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(validateCrewAdd, payload);
    yield put({ type: types.VALIDATE_CREW_ADD_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.VALIDATE_CREW_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* validateCrewDetailsSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(validateCrewDetails, payload);
    yield put({ type: types.VALIDATE_CREW_DETAILS_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.VALIDATE_CREW_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

